module.exports = __webpack_public_path__ + "static/15-4b5013aab9d1ae95606b74a40d851bc6.png";